module.exports = __webpack_public_path__ + "img/cartasi.3f758606.png";